import { ChevronUpIcon } from "@heroicons/react/24/outline";
import { UserIcon } from "@heroicons/react/24/solid";
import React from "react";
import "./css/EHOrgChartNode.css";

const EHOrgChartNode = (props) => {
  const {
    childrenCount,
    reportsToFullName: fullName,
    reportsTitle: title,
    businessUnit,
    market,
    employeeHierarchyState,
    district,
    team,
    employeeNumber,
  } = props.node.data;

  const { employeeId } = props;

  const parent_depth = props.node.parent?.depth;
  const { depth, row } = props.node;

  const colors_depth = [
    "#203A75",
    "#2C5B8D",
    "#0C77BD",
    "#069EDB",
    "#58C9FE",
    "#9CE0FF",
    "#D2F1FF",
  ];

  const primary =
    (!row ? colors_depth[depth] : colors_depth[parent_depth + 1]) ??
    colors_depth[colors_depth.length - 1];

  const darkIcon = ["#D2F1FF", "#9CE0FF"];
  const lightENumber = ["#069EDB", "#0C77BD", "#203A75", "#2C5B8D", "#58C9FE"];

  const iconColor = darkIcon.includes(primary) ? "#203A75" : "white";
  const textColor = lightENumber.includes(primary) ? "white" : "black";

  return (
    <>
      <div className="relative w-96 h-32">
        <div
          className="w-10 h-8 absolute -right-[16px] top-[17px] rounded-br-[80%]"
          style={{ backgroundColor: primary }}
        ></div>
        <div
          className="p-2 px-5 rounded-tr-xl rounded-bl-xl rounded-tl-xl absolute top-0 -right-4 -translate-y-1/2 z-20 shadow-md"
          style={{ background: primary }}
        >
          <p className="text-lg" style={{ color: textColor }}>
            {employeeNumber?.trim() ? employeeNumber : "Pending"}
          </p>
        </div>
        <div
          className="absolute top-0 left-0 w-full h-full bg-white rounded-3xl border z-10 p-3 flex gap-3 shadow-md"
          style={{ borderColor: primary }}
        >
          <div
            className="rounded-full w-fit p-3 h-fit"
            style={{ backgroundColor: primary }}
          >
            <UserIcon className={"w-6"} style={{ fill: iconColor }} />
          </div>

          <div className="font-base mt-2">
            <h1 className="font-bold underline text-lg decoration-2 underline-offset-4 node_card_name w-fit">
              {fullName}
            </h1>
            <div className="text-gray mt-2 text-base">
              <h2>{businessUnit ? `${title}, ${businessUnit}` : title}</h2>
              <p className="truncate w-72">
                {[market, employeeHierarchyState].filter(Boolean).join(" | ")}
                {(district || team) &&
                  (market || employeeHierarchyState) &&
                  " | "}
                {district && team
                  ? `${district}, ${team}`
                  : district || team || ""}
              </p>
            </div>
          </div>
          {row !== undefined && childrenCount > 0 && (
            <button className="absolute left-0 -bottom-3 right-0 bg-white mx-auto w-fit flex p-1 gap-[3px] rounded-md items-center border node_card_expand">
              <ChevronUpIcon className="w-2" />
              <p className=" opacity-40 text-[10px]">{childrenCount}</p>
            </button>
          )}
        </div>
        <div
          className={`absolute w-full h-full rounded-3xl -left-2 -bottom-2 ${
            props.node.data.employeeId === employeeId ? "highlight" : ""
          }`}
          style={{ backgroundColor: primary }}
        ></div>
      </div>
    </>
  );
};

EHOrgChartNode.propTypes = {};

export default EHOrgChartNode;
